<template>
  <v-app dark>
    <v-col>
      <ValidationObserver ref="pollValidation"
                          v-slot="{ invalid, passes }">
        <h1 class="mb-6 mt-0">
          Onemocnění v rodině
        </h1>

        <p>
          Vyskytlo se některé z následujících onemocnění u Vás nebo ve Vaší rodině?
        </p>

        <ul>
          <li>
            Alzheimerova choroba
          </li>
          <li>
            Parkinsonova choroba
          </li>
          <li>
            Bechtěrevova choroba
          </li>
          <li>
            Crohnova choroba
          </li>
          <li>
            Wilsonova choroba
          </li>
          <li>
            Hemochromatóza
          </li>
          <li>
            Gilbertův syndrom
          </li>
          <li>
            Opakované těhotenské ztráty
          </li>
          <li>
            Vrozené vývojové vady
          </li>
          <li>
            Mentální retardace
          </li>
          <li>
            Jiné
          </li>
        </ul>

        <v-row>
          <v-col
            cols="auto">
            <VRadioWithValidation
              rules="required"
              v-model="noInformation"
              row>
              <v-radio color="blue lighten-1"
                       label="Ano"
                       :value="2" />
              <v-radio color="blue lighten-1"
                       label="Ne"
                       :value="true" />
            </VRadioWithValidation>
          </v-col>
        </v-row>

        <template
          v-if="noInformation === 2">
          <v-btn
            @click="addCard('siblings')"
            class="mt-4 mb-4"
            color="blue lighten-1 white--text"
            depressed>
            Přidat příbuzného
          </v-btn>

          <v-card
            v-for="(sibling, i) in otherPerson"
            :key="i + '-siblings'"
            class="pa-3"
            outlined>
            <v-row>
              <v-col
                cols="12"
                class="text-right">
                <v-btn
                  @click="removeCard(i, 'siblings')"
                  class="ml-auto"
                  color="indigo lighten-4"
                  depressed>
                  Odstranit
                </v-btn>
              </v-col>
              <v-col
                cols="2">
                <v-text-field
                  v-model="otherPerson[i].yearBirth"
                  label="Rok narození" />
              </v-col>
              <v-col
                cols="6">
                <v-row v-if="otherPerson[i].diseases.length">
                  <v-col>
                    <v-chip
                      class="ma-2"
                      v-for="(sick, j) in otherPerson[i].diseases"
                      :key="j"
                      close
                      @click:close="removeCardChip(otherPerson[i], j)">
                      {{ sick.value }},
                      {{ sick.year }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row class="align-center">
                  <v-col
                    class="pt-0"
                    cols="6">
                    <v-text-field
                      v-model="otherPerson[i].addingName"
                      label="Onemocnění" />
                  </v-col>
                  <v-col
                    class="pt-0"
                    cols="4">
                    <v-text-field
                      v-model="otherPerson[i].addingAge"
                      label="Věk diagnózy" />
                  </v-col>
                  <v-col
                    class="pt-0"
                    cols="2">
                    <v-btn fab
                           small
                           color="green darken-1 text--white"
                           @click="addSickCard(otherPerson[i])">
                      <v-icon>add</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="2">
                <VRadioWithValidation
                  v-model="otherPerson[i].alive"
                  row
                  custom-class="mt-2">
                  <v-radio color="blue lighten-1"
                           label="Žije"
                           :value="true" />
                  <v-radio color="blue lighten-1"
                           label="Nežije"
                           :value="1" />
                </VRadioWithValidation>
              </v-col>
              <v-col
                v-if="otherPerson[i].alive === 1"
                cols="2">
                <VTextFieldWithValidation
                  :rules="(otherPerson[i].alive === 1 && noInformation === 2) ? 'required' : ''"
                  v-model="otherPerson[i].ageDeath"
                  label="Věk úmrtí"
                  mode="lazy" />
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="6">
                <VTextFieldWithValidation
                  :rules="noInformation === 2 ? 'required' : ''"
                  v-model="otherPerson[i].relationship"
                  label="Příbuzenský vztah"
                  mode="lazy" />
              </v-col>
            </v-row>
          </v-card>
        </template>
        <v-col
          cols="auto">
          <v-btn @click="submit()"
                 type="submit"
                 x-large
                 depressed
                 height="68px"
                 class="px-12 white--text"
                 color="blue lighten-1">
            Uložit
          </v-btn>
        </v-col>
      </ValidationObserver>
    </v-col>
  </v-app>
</template>

<script>
export default {
  name: 'TheOtherDiseases',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      noInformation: null,
      otherPerson: []
    };
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    addCard(type) {
      this.otherPerson.push({
        yearBirth: '',
        ageDeath: '',
        diseases: [],
        alive: null
      });
    },
    // eslint-disable-next-line no-unused-vars
    removeCard(i, type) {
      this.otherPerson.splice(i, 1);
    },
    addSickCard(obj) {
      if (!obj.addingAge || !obj.addingAge.length) {
        return;
      }
      obj.diseases.push({
        value: obj.addingName,
        year: obj.addingAge,
      });

      obj.addingName = '';
      obj.addingAge = '';
    },
    removeCardChip(obj, index) {
      obj.diseases.splice(index, 1);
    },
    async submit() {
      const valid = await this.$refs.pollValidation.validate();

      if (!valid) {
        return false;
      }

      const form = this.formtToSend;
      form.CustomerId = this.id;

      document.getElementById('genscanLogoDiv').scrollIntoView();

      this.axios.put('admin/questionnaires/otherdiseases', form).then((res) => {
        if (res.status === 200) {
          this.$root.$bvToast.toast(this.$t('Questionnaires.SuccessToast.Body'), {
            title: this.$t('Questionnaires.SuccessToast.Title'),
            variant: 'success',
            toaster: 'b-toaster-top-right'
          });
          this.$emit('completed');
        }
      }).catch(() => {
        this.$root.$bvToast.toast(this.$t('Questionnaires.FailureToast.Body'), {
          title: this.$t('Questionnaires.FailureToast.Title'),
          variant: 'danger',
          toaster: 'b-toaster-top-right'
        });
      });

      return true;
    }
  },
  computed: {
    formtToSend() {
      const persons = [];

      this.otherPerson.forEach((person) => {
        persons.push({
          yearBirth: person.yearBirth,
          diseaseType: JSON.stringify(person.diseases),
          relationship: person.relationship,
          ageDiagnosis: 'noneed',
          alive: this.noInformation === true ? true : (person.alive !== 1),
          ageDeath: person.ageDeath
        });
      });

      // eslint-disable-next-line no-new-object
      return new Object({
        userId: this.$store.state['vue-auth'].user ? this.$store.state['vue-auth'].user.id : '',
        otherPerson: persons,
        noInformation: this.noInformation !== 2
      });
    }
  },
  created() {
    this.axios.get('admin/questionnaires/otherdiseases', {
      params: {
        CustomerId: this.id
      }
    }).then((response) => {
      const data = response.data.result;

      this.noInformation = data.noInformation === false ? 2 : true;

      data.otherPerson.forEach((person) => {
        this.otherPerson.push({
          yearBirth: person.yearBirth,
          diseases: JSON.parse(person.diseaseType),
          relationship: person.relationship,
          ageDeath: person.ageDeath,
          alive: person.alive === false ? 1 : true
        });
      });
    });
  }
};
</script>
